const isLocalhost = (hostname = '') => ['localhost', '127.0.0.1', '::1'].includes(String(hostname).toLowerCase());

export const safeExternalUrl = (value, { allowBlob = true } = {}) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'https://telcofair.invalid';
    const parsed = new URL(raw, base);
    const protocol = String(parsed.protocol || '').toLowerCase();
    if (protocol === 'https:') return parsed.href;
    if (protocol === 'http:' && isLocalhost(parsed.hostname)) return parsed.href;
    if (allowBlob && protocol === 'blob:') return parsed.href;
    return '';
  } catch {
    return '';
  }
};

export const openSafeExternalUrl = (value, options = {}) => {
  if (typeof window === 'undefined') return false;
  const href = safeExternalUrl(value, options);
  if (!href) return false;
  const opened = window.open(href, '_blank', 'noopener,noreferrer');
  if (opened) opened.opener = null;
  return true;
};
